import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import {
  StandardDialog,
  Button
} from '@roc/ui';
import EditPointOfContactForm from './editPointOfContactForm';
import { useDrawsStore } from '../hooks';

import { PointsOfContactsTable } from './pointOfContactTable'
import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface PointOfContactDialogProps {
  open: boolean;
  onClose: () => void;
  isInternalValuationPropertyPhotosContactFlow?: boolean;
  document: Document;
}

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: 24,
    marginTop: 24
  },
}));

export const PointOfContactDialog = observer(({ open, onClose, document, isInternalValuationPropertyPhotosContactFlow }: PointOfContactDialogProps) => {
  const classes = useStyles();
  const { pointOfContactStore, drawStore } = useDrawsStore();
  const { pointOfContactFormStore } = pointOfContactStore;
  const drawId = document?.drawId;
  const showTablePoCList = (pointOfContactStore.isMobileSnapDrawEnabled() && pointOfContactFormStore.form.fields.inspectionProcess.value === 'Snap') || drawStore?.drawDTO?.draw?.inspectionCompany === 'Self Inspection Mobile' || isInternalValuationPropertyPhotosContactFlow;
  const taskId = document?.taskId;

  const handleConfirm = () => {
    pointOfContactFormStore.runFormValidation();
    if (pointOfContactFormStore.form.meta.isValid) {
      pointOfContactStore.savePointOfContact(drawId, pointOfContactFormStore.getFormValues());
      onClose();
    }
  };

  useEffect(() => {
    return () => pointOfContactStore.resetStore();
  }, [])

  useEffect(() => {
    if (open) {
      pointOfContactStore.getPointOfContact(`${document?.loanId}`);
    }
  }, [pointOfContactStore, open, document])

  const getContent = () => {
    return !showTablePoCList ? <>
      <EditPointOfContactForm />
      <Grid item container className={classes.buttonContainer}>
        <Box mr={2}>
          <Button
            className={classes.button}
            size="small"
            variant="contained"
            color="secondary"
            onClick={onClose}
            testId="cancel"
          >
            CANCEL
          </Button>
          <Button
            className={classes.button}
            size="small"
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            testId="save"
          >
            SAVE
          </Button>
        </Box>
      </Grid>
    </> : <PointsOfContactsTable isInternalValuationPropertyPhotosContactFlow={isInternalValuationPropertyPhotosContactFlow}
      emptyMessage='No point of contact'
      store={pointOfContactStore} drawStore={drawStore} />;
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Point of Contact"
          handleClose={onClose}
          dialogContent={getContent()}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Point of Contact"
          maxWidth={showTablePoCList ? 'lg' : 'sm'}
          handleClose={onClose}
          dialogContent={getContent()}
        />
      )}
    </>
  )
});
